import ViewViewModel from '@/ViewModels/ViewViewModel';
import ListViewHelper from '@/Utility/ListViewHelper';
import * as CoreFrameDTOs from "coreframetypings/dto";
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import Config from '@/Management/GlobalConfiguration';
import RADApplication from '@/Management/RADApplication';
import FrontController from '@/Management/FrontController';
import ResourceManager from '@/Management/ResourceManager';
import ComponentManager from '@/Management/ComponentManager';
import NavigationHelper from '@/Management/NavigationHelper';
import PrincipalHelper from '@/Utility/PrincipalHelper';
import NavigationService from '@/Management/NavigationService';
import Loader from '@/Utility/Loader';
import LocatorHelper from '@/Utility/LocatorHelper';
import Utilities from '@/Utility/Utilities';
import Messenger from '@/Utility/Messenger';
import UIListener from '@/UIListener/UIListener';
import StorageHelper from '@/Utility/StorageHelper';
import * as DownloadHelper from '@/Utility/DownloadHelper';
import FilterHelper from '@/Utility/FilterHelper';
import TypeSelectorWindowT from '@/Controls/TypeSelectorWindow';
import TableConfigViewModelT from '@/ViewModels/Views/TableConfigViewModel';
import LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import ToolBarViewModelT from '@/ViewModels/Controls/ToolBarViewModel';
import DetailViewContextT from '@/ViewModels/Contexts/DetailViewContext';
import SplitterViewModelT from '@/ViewModels/Controls/SplitterViewModel';
import DataGridViewModelT from '@/ViewModels/Controls/DataGridViewModel';
import MultiLinkViewModelT from '@/ViewModels/Controls/MultiLinkViewModel';
import MessageBoxViewModelT from '@/ViewModels/Controls/MessageBoxViewModel';
import BreadCrumbViewModelT from '@/ViewModels/Controls/BreadCrumbViewModel';
import SplitterPaneViewModelT from '@/ViewModels/Controls/SplitterPaneViewModel';
import SplitterPaneDividerViewModelT from '@/ViewModels/Controls/SplitterPaneDividerViewModel';
import ToolBarSpacerViewModelT from '@/ViewModels/Controls/ToolBarSpacerViewModel';
import TypeSelectorWindowViewModelT from '@/ViewModels/Controls/TypeSelectorWindowViewModel';
import ListViewDataGridHelper from '@/Components/ListView/Helper/ListViewDataGridHelper';
import {
    IDataGridViewModelConstructorParameter,
    IListViewViewModel,
    IListViewViewModelParameters,
    IFilterViewModelConstructorParameter,
    ToolBarItemViewModel, ILabelViewModelConstructorParameter, CustomFilterChip
} from '#/DefaultViewExtensionInterfaces';
import FilterLinkViewModel from '@/Components/Links/FilterLink/FilterLinkViewModel';
import PublicFilterEditLinkViewModel from '@/Components/Links/FilterLink/PublicFilterEditLinkViewModel';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import { IListViewDTO } from "coreframetypings/dto";
import { toLocaleString } from '@/Utility/NumericTypeHelper';
import GlobalConfiguration from "@/Management/GlobalConfiguration";

/**
 * Repräsentiert das ViewModel einer ListView
 */
export default class ListViewViewModel extends ViewViewModel implements IListViewViewModel {

    protected TypeSelectorWindow = ComponentManager.getControl<typeof TypeSelectorWindowT>('TypeSelectorWindow');
    protected TableConfigViewModel = ComponentManager.getViewModel<typeof TableConfigViewModelT>('TableConfigViewModel');
    protected LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>('LinkViewModel');
    protected ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
    protected ToolBarViewModel = ComponentManager.getViewModel<typeof ToolBarViewModelT>('ToolBarViewModel');
    protected DetailViewContext = ComponentManager.getViewModel<typeof DetailViewContextT>('DetailViewContext');
    protected SplitterViewModel = ComponentManager.getViewModel<typeof SplitterViewModelT>('SplitterViewModel');
    protected MultiLinkViewModel = ComponentManager.getViewModel<typeof MultiLinkViewModelT>('MultiLinkViewModel');
    protected BreadCrumbViewModel = ComponentManager.getViewModel<typeof BreadCrumbViewModelT>('BreadCrumbViewModel');
    protected MessageBoxViewModel = ComponentManager.getViewModel<typeof MessageBoxViewModelT>('MessageBoxViewModel');
    protected SplitterPaneViewModel = ComponentManager.getViewModel<typeof SplitterPaneViewModelT>('SplitterPaneViewModel');
    protected SplitterPaneDividerViewModel = ComponentManager.getViewModel<typeof SplitterPaneDividerViewModelT>('SplitterPaneDividerViewModel');
    protected ToolBarSpacerViewModel = ComponentManager.getViewModel<typeof ToolBarSpacerViewModelT>('ToolBarSpacerViewModel');
    protected TypeSelectorWindowViewModel = ComponentManager.getViewModel<typeof TypeSelectorWindowViewModelT>('TypeSelectorWindowViewModel');

    protected listViewDataGridHelper: ListViewDataGridHelper<DataGridViewModelT, IDataGridViewModelConstructorParameter>;

    public pageTitle: string | BreadCrumbViewModelT;
    public _HeaderTitle: string;
    public _tableConfigOpened: boolean;
    private _selectBaseObjectWindowViewModel;

    public currentSummaryViewPDO: KnockoutObservable<string>;

    /**
     * Die ID des aktuellen PersistenceContext
     */
    private persistenceContextId;

    /**
     * Der aktuelle UIListener
     */
    public uiListener;

    /**
     * Die ListView
     */
    public listView: KnockoutObservable<IListViewDTO>;

    /**
     * Ein Observable zur Aktualisierung der SummaryView
     */
    public _refreshSummaryView: KnockoutObservable<boolean>;

    public preFilter: string;
    public customFilterChips: KnockoutObservable<Array<CustomFilterChip>>
    public filter: string;
    public serializedFilter;

    protected preFilterTooltip: string;

    // Übernommen aus der Factory, um Abhängigkeiten zu dieser aufzulösen
    public isEmbedded: boolean;
    public selectedPDO: any;
    public openFullScreenSummaryView: boolean;
    public forceSelectingLVByName;

    /**
     * Enthält ggf. die PDO-ID des Objekts, von dem diese ListView geöffnet wurde.
     */
    public contextObject: string;

    /**
     * Enthält ggf. den PDTypeName des Objekts, von dem diese ListView ggf. geöffnet wurde.
     */
    public contextTypeName: string;

    /**
     * Enthält ggf. den Namen der Relation des Ausgangsobjekts, welche nun als Liste dargestellt wird
     */
    public contextRelation: string;

    /**
     * Sagt aus, ob die Informationen zum Context ignoriert werden sollen
     */
    public ignoreContext: boolean;

    public principalFilterMode: KnockoutObservable<string>;
    public disablePrincipalFilter: boolean;
    public historyDate: any;
    public showPrincipalFilter: boolean;

    /**
     * Gibt den Namen der View zurück
     */
    private readonly viewName: string;

    /**
     * Gibt die ID der View zurück
     */
    private readonly viewId: string;

    public titleExtension: string;

    public _detailViewContextCounter: number;

    public splitterHorizontal: SplitterViewModelT;
    public splitterVertical: SplitterViewModelT;
    public dataGrid: DataGridViewModelT;
    public toolBar: ToolBarViewModelT;

    /**
     * True if the viewmodel is currently refreshing
     */
    public isRefreshing: boolean;

    public isLazy: KnockoutObservable<boolean>;

    /**
     * Gibt an, ob die vertikale SummaryView geöffnet ist
     */
    public verticalSummaryViewIsOpen: KnockoutObservable<boolean>;

    /**
     * Gibt an, ob die horizontale SummaryView geöffnet ist
     */
    public horizontalSummaryViewIsOpen: KnockoutObservable<boolean>;

    /**
     * Gibt an, ob die vertikale SummaryView manuell geschlossen wurde (per Klick durch den User)
     */
    public verticalSummaryViewClosed: boolean;

    /**
     * Gibt an, ob die horizontale SummaryView manuell geschlossen wurde (per Klick durch den User)
     */
    public horizontalSummaryViewClosed: boolean;

    public notDeletableIds: KnockoutObservableArray<string>;

    public showButtonCreate: KnockoutObservable<boolean>;
    public showButtonEdit: KnockoutObservable<boolean>;
    public showButtonDelete: KnockoutObservable<boolean>;

    public constructor(params: IListViewViewModelParameters) {
        super(params);

        this.undisposeProperties.push('hideLoader', 'isEmbedded');
        this.blacklist.push('hideLoader', 'isEmbedded');

        this.pageTitle = "";
        this._HeaderTitle = "";
        this._tableConfigOpened = false;
        this._selectBaseObjectWindowViewModel = null;
        this.persistenceContextId = null;
        this.uiListener = null;
        this.listView = this.observableOrDefault(null);
        this._refreshSummaryView = this.observableOrDefault(false).extend({ notify: 'always' });
        this.preFilter = this.paramOrDefault(params.preFilter, '');
        this.preFilterTooltip = this.paramOrDefault(params.preFilterTooltip, this.paramOrDefault(params.titleExtension, ''));
        this.filter = this.paramOrDefault(params.filter, '');
        this.serializedFilter = this.paramOrDefault(params.serializedFilter, null);
    
        this.isEmbedded = this.paramOrDefault(params.isEmbedded, false);
        this.selectedPDO = this.paramOrDefault(params.selectedPDO, -1);
        this.openFullScreenSummaryView = this.paramOrDefault(params.openFullScreenSummaryView, false);
        this.forceSelectingLVByName = this.paramOrDefault(params.forceSelectingLVByName, false);
        this.contextObject = this.paramOrDefault(params.contextObject, '-1');
        this.contextTypeName = this.paramOrDefault(params.contextTypeName, null);
        this.contextRelation = this.paramOrDefault(params.contextRelation, null);
        this.ignoreContext = this.paramOrDefault(params.ignoreContext, false);
        this.historyDate = this.paramOrDefault(params.historyDate, null);
        this.showPrincipalFilter = this.paramOrDefault(params.showPrincipalFilter, true);
        this.viewName = this.paramOrDefault(params.viewName, '');
        this.viewId = this.paramOrDefault(params.viewId, '');
        this.customFilterChips = this.observableOrDefault([]);

        // PrincipalFilterMode
        if (Utilities.isNullOrUndefinedOrBlank(ko.unwrap(params.principalFilterMode))) {
            this.principalFilterMode = StorageHelper.bind(this.getStoragePrincipalFilterModeKey(), PrincipalHelper.principalFilterDefaultClient);
        } else {
            this.principalFilterMode = this.observableOrDefault(params.principalFilterMode, PrincipalHelper.principalFilterDefaultClient);
        }

        this.disablePrincipalFilter = this.paramOrDefault(params.disablePrincipalFilter, false);

        this.titleExtension = this.paramOrDefault(params.titleExtension, null);
        this.isLazy = this.observableOrDefault(params.isLazy, false);

        this._detailViewContextCounter = 0;

        this.isRefreshing = false;

        this.currentSummaryViewPDO = this.observableOrDefault(null);

        // Sichtbarkeiten / Ausblender SummaryViews
        this.verticalSummaryViewIsOpen = this.observableOrDefault(false);
        this.horizontalSummaryViewIsOpen = this.observableOrDefault(false);
        this.defineSubscription(this.verticalSummaryViewIsOpen,
            (isOpen) => { this.verticalSummaryViewClosed = !isOpen });
        this.defineSubscription(this.horizontalSummaryViewIsOpen,
            (isOpen) => { this.horizontalSummaryViewClosed = !isOpen });
        this.verticalSummaryViewClosed = false;
        this.horizontalSummaryViewClosed = false;

        this.notDeletableIds = this.observableOrDefault(params.notDeletableIds, []) as KnockoutObservableArray<string>;
        this.showButtonCreate = this.observableOrDefault(params.showButtonCreate, true);
        this.showButtonEdit = this.observableOrDefault(params.showButtonEdit, true);
        this.showButtonDelete = this.observableOrDefault(params.showButtonDelete, true);

        if (!params.isInherited) {
            this.init();
        }
    }

    protected init(): void {
        $.when(this.createPersistenceContext()).then((contextCreated: boolean) => {
            if (this.isDisposed || !contextCreated)
                return;

            this.loadListView();
        });
    }

    protected getStoragePrincipalFilterModeKey(): string {
        let viewName = this.getViewName();
        let viewId = this.getViewId();
        let prefix = '';
        if (!Utilities.isNullOrUndefinedOrBlank(viewName))
            prefix = viewName;
        else
            prefix = viewId;

        return `${prefix}_PRINCIPAL_FILTER_MODE`;
    }

    public getStorageColumnDefinitionKey(listViewDto: CoreFrameDTOs.IListViewDTO) {
        if (!listViewDto || !listViewDto.columns)
            return null;

        return listViewDto.columns.length > 0 ? listViewDto.name + '_ColumnDefinition' : null;
    }

    /**
     * Schließt die vertikale SummaryView (temporär), sodass sie, anders als nach einem manuellen Schließen, erneut geöffnet wird
     */
    public closeVerticalSummaryViewTemporarily(): void {
        const old = this.verticalSummaryViewClosed;
        this.verticalSummaryViewIsOpen(false);
        this.verticalSummaryViewClosed = old;
    }

    /**
     * Schließt die horizontale SummaryView (temporär), sodass sie, anders als nach einem manuellen Schließen, erneut geöffnet wird
     */
    public closeHorizontalSummaryViewTemporarily(): void {
        const old = this.horizontalSummaryViewClosed;
        this.horizontalSummaryViewIsOpen(false);
        this.horizontalSummaryViewClosed = old;
    }

    /**
     * Methode, die aufgerufen werden sollte, wenn ein invalides / korruptes oder gelöschtes Objekt selektiert wurde
     */
    public onCorruptElementSelected(): void {
        this.selectedPDO = -1;
        this.dataGrid.selected([]);
        this.refresh();
    }

    /**
     * Gibt aus, ob dieses ViewModel als Datenquelle eine Assoziation verwendet
     */
    public isAssociationList() {
        return this.contextObject !== '-1' && !String.isNullOrEmpty(this.contextRelation);
    }

    public appendCustomFilterChip(customFilterComponent: CustomFilterChip | Array<CustomFilterChip>) {
        const customData = this.customFilterChips();
        if (Array.isArray(customFilterComponent)) {
            const concatted = customData.concat(customFilterComponent);
            this.customFilterChips(concatted);
        } else {
            customData.push(customFilterComponent)
            this.customFilterChips(customData);
        }
    }

    /**
     * Erstellt einen neuen DetailViewContext
     */
    public createContext(caller, pdTypeName: string, pdoId: string, openInNewWindow: boolean = false) {
        NavigationHelper.openDetailView('EDIT', pdTypeName, { pdoId: pdoId }, openInNewWindow);
    }

    public openDetailViewForCreation(typeName: string) {
        if (this.isAssociationList() && !this.ignoreContext) {
            NavigationHelper.openDetailViewAndConnect('CREATE', typeName, this.contextObject, this.contextTypeName, this.contextRelation);
        }
        else {
            NavigationHelper.openDetailView('CREATE', typeName);
        }
    }

    /**
     * Erstellt einen neuen NestedDetailViewContext
     */
    public createNestedContext(nestedContextName: string, caller: DetailViewContext) {
        let nestedDetailViewContextDTO = caller._nestedDetailViewContextDTOs._findByName(nestedContextName);

        let nestedDetailViewContext = new this.DetailViewContext({
            parentLocator: this.locator,
            locator: 'dv-nested.[' + nestedContextName + ']',
            viewModel: this,
            caller: caller,
            pdoId: -1,
            detailViewContextDTO: nestedDetailViewContextDTO,
            nestedContextName: nestedContextName,
            action: 'CREATE'
        });

        return nestedDetailViewContext;
    }

    /**
     * Entfernt den aktuellen PersistenceContext
     */
    public deletePersistenceContext() {
        if (this.persistenceContextId == null)
            return undefined;

        return RADEnvironmentProxy.getInstance().deletePersistenceContext({
            persistenceContextID: this.persistenceContextId
        }).then((result) => {
            if (result !== false) {
                this.persistenceContextId = null;
            }

            return result;
        });
    }

    /**
     * Erstellt einen PersistenceContext
     */
    public createPersistenceContext(): JQueryPromise<boolean> {
        if (this.persistenceContextId == null) {
            return RADEnvironmentProxy.getInstance().createPersistenceContext().then((id) => {
                this.persistenceContextId = id;
                return true;
            }).promise();
        }

        return Utilities.resolveImmediately(true);
    }

    /**
     * Erzeugt einen für die ListView gültigen UIListener
     */
    public createUIListener(listView) {
        this.uiListener = UIListener.createInstance(listView.uiListener);
    }

    /**
     * Erzeugt das ViewModel für den vertikalen Splitter
     */
    public createVerticalSplitter(listView: IListViewDTO): SplitterViewModelT {
        const listViewPane = this.createHorizontalListViewSplitterPane();
        const summaryViewPane = this.createHorizontalSummaryViewSplitterPane(listView);

        const divider = new this.SplitterPaneDividerViewModel({
            attachedTo: summaryViewPane
        });

        return new this.SplitterViewModel({
            isHorizontal: false,
            panes: [
                listViewPane,
                summaryViewPane,
            ],
            dividers: [
                divider
            ]
        });
    }

    protected createHorizontalListViewSplitterPane(): SplitterPaneViewModelT {
        return new this.SplitterPaneViewModel({
            isExpanded: true,
            isCollapsible: false,
            isResizable: true,
            isScrollable: true,
            collapsedSize: 0,
            size: null,
            min: "0",
            max: null,
            isBusy: this.dataGrid.isBusy
        });
    }

    protected createHorizontalSummaryViewSplitterPane(listView: IListViewDTO): SplitterPaneViewModelT {
        const size = StorageHelper.bind(listView.name + '_SummaryViewScreenRatio', '35%');
        this.addComputed(size);
        return new this.SplitterPaneViewModel({
            isExpanded: this.horizontalSummaryViewIsOpen,
            isVisible: false,
            isCollapsible: true,
            isResizable: true,
            isScrollable: true,
            collapsedSize: 0,
            size: size,
            min: "0",
            max: null,
            parentLocator: this.locator,
            locator: LocatorHelper.buildLocator(this.locator, listView.typeName, 'splitterpane', 'summaryview', 'horizontal')
        });
    }

    /**
     * Erzeugt das ViewModel für den horizontalen Splitter
     */
    public createHorizontalSplitter(listView: IListViewDTO): SplitterViewModelT {
        const listViewPane = this.createVerticalListViewSplitterPane(listView);
        const summaryViewPane = this.createVerticalSummaryViewSplitterPane(listView);

        const divider = new this.SplitterPaneDividerViewModel({
            attachedTo: summaryViewPane
        });

        return new this.SplitterViewModel({
            isHorizontal: true,
            panes: [
                listViewPane,
                summaryViewPane
            ],
            dividers: [
                divider
            ]
        });
    }

    protected createVerticalListViewSplitterPane(listView: IListViewDTO): SplitterPaneViewModelT {
        return new this.SplitterPaneViewModel({
            isExpanded: true,
            isCollapsible: false,
            isResizable: true,
            isScrollable: false,
            collapsedSize: null,
            size: null,
            min: "0",
            max: null,
            parentLocator: this.locator,
            locator: LocatorHelper.buildLocator(this.locator, listView.typeName, 'splitterpane', 'listview')
        })
    }

    protected createVerticalSummaryViewSplitterPane(listView: IListViewDTO): SplitterPaneViewModelT {
        const size = StorageHelper.bind(listView.name + '_SummaryViewScreenRatio', '35%');
        this.addComputed(size);
        return new this.SplitterPaneViewModel({
            isExpanded: this.verticalSummaryViewIsOpen,
            isVisible: false,
            isCollapsible: true,
            isResizable: true,
            isScrollable: true,
            collapsedSize: 0,
            size: size,
            min: "0",
            max: null,
            parentLocator: this.locator,
            locator: LocatorHelper.buildLocator(this.locator, listView.typeName, 'splitterpane', 'summaryview', 'vertical')
        });
    }

    protected onEdit(pdoId: string, openInNewWindow: boolean) {
        if (this.listView().showButtonEdit) {
            this.createContext(this, this.listView().typeName, pdoId, openInNewWindow);
        }
    }

    protected createListViewDataGridHelper(listViewDto: CoreFrameDTOs.IListViewDTO): ListViewDataGridHelper<DataGridViewModelT, IDataGridViewModelConstructorParameter> {
        return new ListViewDataGridHelper<DataGridViewModelT, IDataGridViewModelConstructorParameter>(this, listViewDto);
    }

    protected getListViewDataGridHelper(listViewDto: CoreFrameDTOs.IListViewDTO): ListViewDataGridHelper<DataGridViewModelT, IDataGridViewModelConstructorParameter> {
        if (this.listViewDataGridHelper == null) {
            this.listViewDataGridHelper = this.createListViewDataGridHelper(listViewDto);
        }

        return this.listViewDataGridHelper;
    }

    /**
     * Erzeugt das ViewModel für das DataGrid
     */
    public createDataGrid(listView: CoreFrameDTOs.IListViewDTO): void {
        let parameters = this.createDataGridViewModelParameters(listView);

        this.dataGrid = this.listViewDataGridHelper.createDataGridViewModel(parameters) as DataGridViewModelT;
    }

    /**
     * Updates data grid
     * @param listView the listview data tranfer object
     * @param viewRefreshed is the whole view or just data refreshed?
     */
    private updateDataGrid(listView: CoreFrameDTOs.IListViewDTO, viewRefreshed: boolean) {
        const columnDefinition = ListViewHelper.loadColumnDefinitions(this.getStorageColumnDefinitionKey(listView), listView.columns);
        this.dataGrid.columnDefinition(columnDefinition() as any);
        this.dataGrid.refresh().then(() => {
            if (Utilities.isNotBlank(this.selectedPDO) && this.selectedPDO != -1) {
                if (this.dataGrid.data().map(item => item.PDO_ID).indexOf(this.selectedPDO) > -1)
                    this.dataGrid.selected([this.selectedPDO]);
                else {
                    this.selectedPDO = -1;
                    this.dataGrid.selected([]);
                }
            }
        });
    }

    protected showAllFilterFunctions(): boolean {
        return !this.isAssociationList() && !this.isEmbedded;
    }

    protected createDataGridViewModelParameters(listView: CoreFrameDTOs.IListViewDTO): IDataGridViewModelConstructorParameter {
       let associationName = null;
        let associationPdoId = null;
        let associationType = null;

        if (this.isAssociationList() && !this.ignoreContext) {
            associationName = this.contextRelation;
            associationPdoId = this.contextObject;
            associationType = this.contextTypeName;
        }

        const helper = this.getListViewDataGridHelper(listView);
        helper.setAdditionalFilterConstructorParameter(this.createAdditionalFilterConstructorParameter(listView));

        helper.setAdditionalDataGridConstructorParameters({
            isAssociationDataGrid: listView.assoziationListView,
            pdTypeName: listView.typeName,
            page: 1,
            suppressOnce: JSON.parse(this.serializedFilter) != null,
            associationName: associationName,
            associationPdoId: associationPdoId,
            associationType: associationType,
            onDoubleClickHandler: (pdoId: any, dataRow: any, openInNewWindow: boolean) => {
                this.onEdit(pdoId, openInNewWindow);
            },
            defaultOrder: listView.defaultOrder,
            rowLimit: listView.rowLimit,
            principalFilterMode: this.principalFilterMode,
            disablePrincipalFilter: this.disablePrincipalFilter,
            historyDate: this.historyDate,
            isPrincipalIndependent: listView.isPrincipalIndependent,
            isLazy: this.isLazy,
            renderGridAsync: true,
            customFilterChips: this.customFilterChips
        });

        return helper.createDataGridViewModelParameters();
    }

    protected createAdditionalFilterConstructorParameter(listView: CoreFrameDTOs.IListViewDTO): IFilterViewModelConstructorParameter{
        // Es sollen nur alle Filterfunktionen auf einer normalen LV angezeigt werden
        // Auf einer ALV oder in einer Embedded-LV (im Standard) werden die erweiterten Filterfunktionen nicht angezeigt
        const showAllFilterFunctions = this.defineComputed(() => {
            return this.showAllFilterFunctions();
        });

        return {
            principalFilterMode: this.principalFilterMode,
            shouldShowChips: showAllFilterFunctions,
            shouldShowSaveInputs: showAllFilterFunctions,
            shouldShowSorting: showAllFilterFunctions,
            preFilterTooltip: this.preFilterTooltip
        }
    }

    /**
     * Erzeugt das ViewModel für den Seitentitel
     */
    public createPageTitle(listView) {
        this.pageTitle = (() => {
            return new this.BreadCrumbViewModel({
                parentLocator: this.locator,
                locator: 'lv-breadcrumbs',
                elements: [
                    this.createPageTitleLabel(listView)
                ]
            });
        })();
    };

    public createPageTitleLabel(listView: CoreFrameDTOs.IListViewDTO) {
        return new this.LabelViewModel({
            prefix: !Config.listView.ShowCountInHeader ? new this.LabelViewModel({ ergName: 'LISTVIEW_PAGETITLE_PREFIX', postfix: ' ' }) : null,
            ergName: listView.ergNamePluralized,
            postfix: Config.listView.ShowCountInHeader ? new this.LabelViewModel({
                caption: this.defineComputed(() => {
                    let totalRows = this.dataGrid.realTotalRows;

                    if (totalRows == null) {
                        return '';
                    }

                    return ` (${toLocaleString(totalRows(), 0)})`;
                })
            }) : null,
            tooltip: new this.LabelViewModel({
                ergName: listView.ergNamePluralized
            }),
            isWordWrapped: true,
            maxLength: 50
        });
    }

    /**
     * Erzeugt das ViewModel für die ToolBar
     */
    public createToolbar(listView: CoreFrameDTOs.IListViewDTO): void {
        this.toolBar = (() => {
            return new this.ToolBarViewModel({
                parentLocator: this.locator,
                locator: listView.typeName + ".toolbar",
                primary: this.createPrimaryToolBarItems(listView),
                secondary: this.createSecondaryToolBarItems(listView),
                extended: this.createExtendedToolBarItems(listView),
            });
        })();
    }

    protected createPrimaryToolBarItems(listView: IListViewDTO): ToolBarItemViewModel[] {
        const items: ToolBarItemViewModel[] = [
            this.createCreateLink(listView),
            this.createEditLink(listView),
            this.createDeleteLink(listView),
        ];

        if (listView.showButtonCreate || listView.showButtonEdit || listView.showButtonDelete) {
            items.push(new this.ToolBarSpacerViewModel({}));
        }

        return items;
    }

    protected createSecondaryToolBarItems(listView: IListViewDTO): ToolBarItemViewModel[] {
        const items: ToolBarItemViewModel[] = [
            this.createRefreshLink(listView),
            new this.ToolBarSpacerViewModel({}),
            ...this.createFilterLinks(listView),
        ];

        /** Hinzufügen des Mandantenfilters unter folgenden Voraussetzungen:
         * 1.) Die ListInfo ist mandanten-unabhängig
         * 2.) Die System-Property ist gesetzt
         * 3.) Es wurde nicht explizit verweigert, dass der Filter angezeigt werden soll.
         * 4.) Wenn es keine AssociationsList ist */
        if (listView.isPrincipalIndependent === false &&
            RADApplication.getInstance().isSystemParamSetAndTrue('Gui.ShowPrincipalFilter') &&
            this.showPrincipalFilter &&
            !this.isAssociationList()) {
            items.push(this.createPrincipalFilterLink(listView));
        }

        items.push(
            new this.ToolBarSpacerViewModel({}),
            this.createTableConfigLink(listView),
            ...this.createExportLinks(listView),
            ...this.createStaticOperationLinks(listView),
        );

        return items;
    }

    protected createExtendedToolBarItems(listView: IListViewDTO): ToolBarItemViewModel[] {
        const items = [];

        if (this.isFavoritesVisible()) {
            items.push(this.createFavoriteLink(listView));
        }

        return items;
    }

    protected createCreateLink(listView: IListViewDTO): LinkViewModelT {
        return new this.LinkViewModel({
            parentLocator: this.locator,
            locator: listView.typeName + ".toolbar.create",
            label: this.createToolbarLabel(listView, {
                parentLocator: this.locator,
                locator: listView.typeName + ".toolbar.create.label",
                ergName: 'CREATE_NEW',
                replacements: {
                    'ergname_sl': new this.LabelViewModel({
                        ergName: listView.ergName
                    })
                }
            }),
            tooltip: new this.LabelViewModel({
                ergName: 'CREATE_NEW_TOOLTIP',
                replacements: {
                    'ergname_sl': new this.LabelViewModel({
                        ergName: listView.ergName
                    })
                }
            }),
            image: new this.ImageViewModel({
                source: Config.inlineImages.TOOLBAR_CREATE,
                parentLocator: this.locator,
                locator: listView.typeName + ".toolbar.create.image",
                alternativeText: new this.LabelViewModel({
                    ergName: 'CREATE_NEW_TOOLTIP',
                    replacements: {
                        'ergname_sl': new this.LabelViewModel({
                            ergName: listView.ergName
                        })
                    }
                })
            }),
            isActive: false,
            isVisible: this.defineComputed(() => {
                return this.showButtonCreate() && listView.showButtonCreate;
            }),
            isEnabled: this.defineComputed(() => {
                return this.dataGrid != null && this.dataGrid.iterator() != null && this.dataGrid.iterator().returnHistoricalData === false;
            }),
            onClick: () => {

                if (listView.types.length > 1) {
                    if (this._selectBaseObjectWindowViewModel == null) {
                        this._selectBaseObjectWindowViewModel = this.TypeSelectorWindowViewModel.createSubTypeSelectorWindow(
                            listView.ergName,
                            listView.types,
                            (typeName) => {
                                this.openDetailViewForCreation(typeName);
                            },
                            this.defineComputed(() => {
                                if (Utilities.isNullOrUndefined(this.locator()))
                                    return null;
                                else
                                    return `${this.locator()}.${listView.typeName}`;
                            }),
                            () => {
                                NavigationService.getInstance().cleanRegion('Modal');
                                this._selectBaseObjectWindowViewModel = null;
                            }
                        );

                        let selectBaseObjectWindow = new this.TypeSelectorWindow(this._selectBaseObjectWindowViewModel);
                        let tuple = selectBaseObjectWindow.getTuple();
                    }
                }
                else if (listView.types.length === 0) {
                    RADApplication.getInstance().showMessageBox(MessageBoxViewModelT.createErrorMessageBox(null, 'PAGE_NOT_FOUND'));
                }
                else {
                    let typeName = listView.typeName;
                    if (listView.types && listView.types[0].name)
                        typeName = listView.types[0].name;
                    this.openDetailViewForCreation(typeName);
                }

            },
            // Wenn in der ListView kein Create Button angezeigt werden soll z.B. in einer EmbeddedListView, dann soll auch der hotkey nicht überschrieben werden
            hotkey: listView.showButtonCreate ? 'alt+n' : null
        });
    }

    protected createEditLink(listView: IListViewDTO): LinkViewModelT {
        return new this.LinkViewModel({
            parentLocator: this.locator,
            locator: listView.typeName + ".toolbar.edit",
            label: this.createToolbarLabel(listView, {
                ergName: 'CREATE_EDIT',
                parentLocator: this.locator,
                locator: listView.typeName + ".toolbar.edit.label",
                replacements: {
                    'ergname_sl': new this.LabelViewModel({
                        ergName: listView.ergName
                    })
                }
            }),
            tooltip: new this.LabelViewModel({
                ergName: 'CREATE_EDIT_TOOLTIP',
                replacements: {
                    'ergname_sl': new this.LabelViewModel({
                        ergName: listView.ergName
                    })
                }
            }),
            image: new this.ImageViewModel({
                source: Config.inlineImages.TOOLBAR_EDIT,
                parentLocator: this.locator,
                locator: listView.typeName + ".toolbar.edit.image",
                alternativeText: new this.LabelViewModel({
                    ergName: 'CREATE_EDIT_TOOLTIP',
                    replacements: {
                        'ergname_sl': new this.LabelViewModel({
                            ergName: listView.ergName
                        })
                    }
                })
            }),
            isActive: false,
            isVisible: this.defineComputed(() => {
                return this.showButtonEdit() && listView.showButtonEdit;
            }),
            isEnabled: this.defineComputed(() => {
                let selected = this.dataGrid.selected();
                return selected.length === 1;
            }),
            onClick: (openInNewWindow: boolean) => {
                let selected = this.dataGrid.selected();
                let typeName = listView.typeName;
                let pdoId = selected[0];
                this.onEdit(pdoId, openInNewWindow);
            }
        });
    }

    protected createDeleteLink(listView: IListViewDTO): LinkViewModelT {
        return new this.LinkViewModel({
            parentLocator: this.locator,
            locator: listView.typeName + ".toolbar.delete",
            label: this.createToolbarLabel(listView, {
                ergName: 'DELETE',
                parentLocator: this.locator,
                locator: listView.typeName + ".toolbar.delete.label",
                replacements: {
                    'ergname_sl': new this.LabelViewModel({
                        ergName: listView.ergName
                    })
                }
            }),
            tooltip: new this.LabelViewModel({
                ergName: 'DELETE_TOOLTIP',
                replacements: {
                    'ergname_sl': new this.LabelViewModel({
                        ergName: listView.ergName
                    })
                }
            }),
            image: new this.ImageViewModel({
                source: Config.inlineImages.TOOLBAR_DELETE,
                parentLocator: this.locator,
                locator: listView.typeName + ".toolbar.delete.image",
                alternativeText: new this.LabelViewModel({
                    ergName: 'DELETE_TOOLTIP',
                    replacements: {
                        'ergname_sl': new this.LabelViewModel({
                            ergName: listView.ergName
                        })
                    }
                })
            }),
            isActive: false,
            isVisible: this.defineComputed(() => {
                return this.showButtonDelete() && listView.showButtonDelete;
            }),
            isEnabled: this.definePureComputed(() => {
                let selectedIds = this.dataGrid.selected().map(s => s.toString());
                let notDeletetableIds = this.notDeletableIds().map(i => i.toString());
                const deletingAllowed = _.all(selectedIds, (pdoId) => notDeletetableIds.indexOf(pdoId) === -1);
                return selectedIds.length > 0 && deletingAllowed && this.dataGrid.iterator() != null && this.dataGrid.iterator().returnHistoricalData === false;
            }),
            onClick: () => {
                let pdoIds = this.dataGrid.selected();

                if (RADApplication.getInstance().isSystemParamSetAndTrue('Gui.ShowTryToDelete')) {
                    Loader.getInstance().show();
                    RADEnvironmentProxy.getInstance().tryToDeleteObject({
                        pdTypeName: listView.typeName,
                        pdoIDs: pdoIds
                    }).then((tryDeletion) => {

                        if (this.validateStatus(tryDeletion)) {
                            this.showDeletionMsgBox(tryDeletion, listView, pdoIds);
                        } else {
                            // Im Fehlerfall Grid neuladen, damit evtl. bereits gelöschte Datensätze verschwinden
                            this.onCorruptElementSelected();
                        }
                    }).always(() => {
                        Loader.getInstance().hide();
                    });
                } else {
                    this.showDeletionMsgBox(null, listView, pdoIds);
                }
            }
        });
    }

    public createToolbarLabel(listView: CoreFrameDTOs.IListViewDTO, params: ILabelViewModelConstructorParameter): LabelViewModelT {
        if (Utilities.isMobileView())
            return null;

        params.isVisible = listView.showToolbarLabel ?? Config.listView.ShowToolbarText;
        return new this.LabelViewModel(params);
    }

    protected createRefreshLink(listView: IListViewDTO): LinkViewModelT {
        return new this.LinkViewModel({
            parentLocator: this.locator,
            locator: listView.typeName + ".toolbar.refresh",
            label: new this.LabelViewModel({
                ergName: 'REFRESH_LIST',
                isVisible: GlobalConfiguration.listView.ShowToolbarText
            }),
            image: new this.ImageViewModel({
                source: Config.inlineImages.REFRESH,
                parentLocator: this.locator,
                locator: listView.typeName + ".toolbar.refresh.image",
                alternativeText: new this.LabelViewModel({
                    ergName: 'REFRESH_TOOLTIP'
                })
            }),
            tooltip: new this.LabelViewModel({
                ergName: 'REFRESH_TOOLTIP'
            }),
            isActive: false,
            isVisible: true,
            isEnabled: this.defineComputed(() => {
                return !this.dataGrid.isBusy();
            }),
            onClick: () => {
                if (this.dataGrid.isBusy()) {
                    return;
                }

                this.refresh();
            }
        });
    }

    protected createPrincipalFilterLink(listView: IListViewDTO): MultiLinkViewModelT {
        return new this.MultiLinkViewModel({
            technicalName: 'lv-principal-filter',
            parentLocator: this.locator,
            locator: listView.typeName + ".toolbar.principalFilter",
            isActive: false,
            isToolBarLink: true,
            isVisible: this.defineComputed(() => {
                const principal = RADApplication.getInstance().principal.name();
                const principalFilterMode = this.principalFilterMode();
                return principalFilterMode !== 'PRINCIPAL_SELECTOR_WITH_BASE'
                    && principalFilterMode !== 'PRINCIPAL_SELECTOR_ALL'
                    && principal != null && principal !== '';
            }),
            tooltip: new this.LabelViewModel({
                ergName: 'PRINCIPAL_SELECTOR_TOOLTIP'
            }),
            selectedChild: this.principalFilterMode,
            items: [
                new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: listView.typeName + ".toolbar.principalFilter.PRINCIPAL_SELECTOR_ONLY_CURRENT",
                    childValue: 'PRINCIPAL_SELECTOR_ONLY_CURRENT',
                    image: new this.ImageViewModel({
                        source: Config.inlineImages.PRINCIPALS_CURRENT,
                        parentLocator: this.locator,
                        locator: listView.typeName + ".toolbar.principalFilter.PRINCIPAL_SELECTOR_ONLY_CURRENT.image",
                        alternativeText: new this.LabelViewModel({
                            ergName: 'PRINCIPAL_SELECTOR_ONLY_CURRENT'
                        })
                    }),
                    label: new this.LabelViewModel({
                        ergName: 'PRINCIPAL_SELECTOR_ONLY_CURRENT',
                        parentLocator: this.locator,
                        locator: listView.typeName + ".toolbar.principalFilter.PRINCIPAL_SELECTOR_ONLY_CURRENT.label"
                    })
                }),
                new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: listView.typeName + ".toolbar.principalFilter.PRINCIPAL_SELECTOR_ONLY_SUB",
                    childValue: 'PRINCIPAL_SELECTOR_ONLY_SUB',
                    image: new this.ImageViewModel({
                        source: Config.inlineImages.PRINCIPALS_SUB,
                        parentLocator: this.locator,
                        locator: listView.typeName + ".toolbar.principalFilter.PRINCIPAL_SELECTOR_ONLY_SUB.image",
                        alternativeText: new this.LabelViewModel({
                            ergName: 'PRINCIPAL_SELECTOR_ONLY_SUB'
                        })
                    }),
                    label: new this.LabelViewModel({
                        ergName: 'PRINCIPAL_SELECTOR_ONLY_SUB',
                        parentLocator: this.locator,
                        locator: listView.typeName + ".toolbar.principalFilter.PRINCIPAL_SELECTOR_ONLY_SUB.label"
                    })
                }),
                new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: listView.typeName + ".toolbar.principalFilter.PRINCIPAL_SELECTOR_CURRENT_AND_SUB",
                    childValue: 'PRINCIPAL_SELECTOR_CURRENT_AND_SUB',
                    image: new this.ImageViewModel({
                        source: Config.inlineImages.PRINCIPALS_CURRENT_SUB,
                        parentLocator: this.locator,
                        locator: listView.typeName + ".toolbar.principalFilter.PRINCIPAL_SELECTOR_CURRENT_AND_SUB.image",
                        alternativeText: new this.LabelViewModel({
                            ergName: 'PRINCIPAL_SELECTOR_CURRENT_AND_SUB'
                        })
                    }),
                    label: new this.LabelViewModel({
                        ergName: 'PRINCIPAL_SELECTOR_CURRENT_AND_SUB',
                        parentLocator: this.locator,
                        locator: listView.typeName + ".toolbar.principalFilter.PRINCIPAL_SELECTOR_CURRENT_AND_SUB.label"
                    })
                })
            ]
        });
    }

    protected createTableConfigLink(listView: IListViewDTO): LinkViewModelT {
        return new this.LinkViewModel({
            parentLocator: this.locator,
            locator: listView.typeName + ".toolbar.tableconfig",
            label: new this.LabelViewModel({
                ergName: 'CUSTOM_COLUMNS_LABEL',
                isVisible: GlobalConfiguration.listView.ShowToolbarText
            }),
            image: new this.ImageViewModel({
                source: Config.inlineImages.TOOLBAR_TABLECONFIG,
                parentLocator: this.locator,
                locator: listView.typeName + ".toolbar.tableconfig.image",
                alternativeText: new this.LabelViewModel({
                    ergName: 'CUSTOM_COLUMNS_TOOLTIP'
                })
            }),
            tooltip: new this.LabelViewModel({
                ergName: 'CUSTOM_COLUMNS_TOOLTIP'
            }),
            isActive: false,
            isVisible: true,
            isEnabled: true,
            onClick: () => {
                if (this._tableConfigOpened)
                    return;
                this._tableConfigOpened = true;
                let storageColumnDefinitionKey = this.getStorageColumnDefinitionKey(listView);
                let columnDefinition = ListViewHelper.loadColumnDefinitions(storageColumnDefinitionKey, listView.columns);
                if (storageColumnDefinitionKey) {
                    this.addComputed(columnDefinition);
                }

                let tableConfig = NavigationService.getInstance().loadViewFactoryIsolated('TableConfig', {
                    viewModel: new this.TableConfigViewModel({
                        userSpecificDataKey: storageColumnDefinitionKey,
                        parentLocator: this.locator,
                        locator: listView.typeName + '.tableconfig',
                        columnDefinition: columnDefinition,
                        defaultDefinition: listView.columns,
                        onClose: () => {
                            this._tableConfigOpened = false;
                            NavigationService.getInstance().removeViewFactoryIsolated(tableConfig);
                        }
                    })
                }, true);
            }
        });
    }

    /**
     * Updates the toolbar
     * @param listView the listview data transfer object
     * @param viewRefreshed is the whole view or just data refreshed?
     */
    protected updateToolbar(listView: CoreFrameDTOs.IListViewDTO, viewRefreshed?: boolean) {
        const newItems = this.createStaticOperationLinks(listView);

        // recreate links for operations because the dto changes
        // the link's computeds (e.g. isEnabled) are not reevaluated because the dto is no observable
        newItems.forEach(item => {
            if (!this.toolBar.isLink(item)) {
                return;
            }

            const oldLink = this.toolBar.getElementByErgName(item.label.ergName())
            // should never happen, because operations are also available if the user has no rights
            // the links are disabled in case of no rights
            if (Utilities.isNullOrUndefined(oldLink)) {
                return;
            }

            const oldIndex = this.toolBar.secondary().indexOf(oldLink);
            this.toolBar.secondary().splice(oldIndex, 1, item);
            this.toolBar.secondary.notifySubscribers(this.toolBar.secondary());

            oldLink.dispose();
        });
    }

    protected isFavoritesVisible(): boolean {
        return RADApplication.getInstance().isSystemParamSetAndTrue('Gui.ShowFavourites');
    }

    protected createFilterLinks(listView: IListViewDTO): LinkViewModelT[] {
        const filterLink = this.createFilterLink(listView);

        const publicFilterLinkViewModel = this.createPublicFilterLink(listView, filterLink);

        if (this.dataGrid.filter?.isVisible()){
            if (this.dataGrid.filter.editPublicChips()) {
                publicFilterLinkViewModel.showPublicFilterEdit();
            }
            else {
                filterLink.showFilter();
            }
        }

        return [
            filterLink,
            publicFilterLinkViewModel
        ];
    }

    protected createFilterLink(listView: IListViewDTO): FilterLinkViewModel {
        return new FilterLinkViewModel({
            dataSource: this.dataGrid,
            listView: listView,
            locator: listView.typeName + '.toolbar.filter',
            parentLocator: this.locator
        });
    }

    protected createPublicFilterLink(listView: IListViewDTO, filterLink: FilterLinkViewModel): PublicFilterEditLinkViewModel {
        return new PublicFilterEditLinkViewModel({
            label: new this.LabelViewModel({
                ergName: 'PUBLIC_FILTER_TOOLTIP',
                isVisible: GlobalConfiguration.listView.ShowToolbarText
            }),
            filterSource: this.dataGrid.filter,
            listView: listView,
            filterLink: filterLink,
            locator: listView.typeName + '.toolbar.filter-edit',
            parentLocator: this.locator
        });
    }

    public showDeletionMsgBox(tryDeletion: CoreFrameDTOs.ITryDeletionDTO, listView: CoreFrameDTOs.IListViewDTO, pdoIds: string[]) {
        RADApplication.getInstance().showMessageBox(this.MessageBoxViewModel.createDeletionMessageBox(tryDeletion, () => {
            Loader.getInstance().show();

            this.deleteObjects(listView.typeName, pdoIds).always(() => {
                Loader.getInstance().hide();
            });
        }));
    }

    public deleteObjects(typeName: string, pdoIds: string[]): JQueryPromise<void> {
        return RADEnvironmentProxy.getInstance().deleteManyObjects({
            pdTypeName: typeName,
            pdoIDs: pdoIds
        }).then((changeObject) => {
            // Immer validieren & ggf. Fehler zeigen
            this.validateStatus(changeObject);
        }).always(() => {
            // Immer Grid neuladen, damit evtl. bereits gelöschte Datensätze verschwinden
            if (!this.isDisposed) {
                this.onCorruptElementSelected();
            }
            this.uiListener.onAfterDeleteFromListView(this);
        });
    }

    public createExportLinks(listView: IListViewDTO): ToolBarItemViewModel[] {
        const links: ToolBarItemViewModel[] = [
            new this.ToolBarSpacerViewModel({}),
            this.buildExportLinkViewModel('XLS', listView.showButtonXLSExport, { isVisible: true }, { isVisible: true, source: Config.inlineImages.XLS_DOCUMENT }, listView.typeName),
            this.buildExportLinkViewModel('CSV', listView.showButtonCSVExport, { isVisible: true }, { isVisible: true, source: Config.inlineImages.CSV_DOCUMENT }, listView.typeName),
            this.buildExportLinkViewModel('PDF', false, { isVisible: false }, { isVisible: true, source: 'FileTypes/pdf.png' }, listView.typeName),
        ];

        return links;
    };

    public createStaticOperationLinks(listView: IListViewDTO): ToolBarItemViewModel[] {
        const links = [];
        if (listView.operations.length > 0) {
            links.push(new this.ToolBarSpacerViewModel({}));
        }

        for (let i = 0; i < listView.operations.length; i++) {
            links.push(this.buildOperationLinkViewModel(listView.operations[i], listView));
        }

        return links;
    }

    private createFavoriteLink(listView: IListViewDTO): LinkViewModelT {
        return new this.LinkViewModel({
            parentLocator: this.locator,
            locator: listView.typeName + '.open-favorite-settings',
            tooltip: new this.LabelViewModel({
                ergName: 'FAVOURITE_TOOLTIP'
            }),
            image: new this.ImageViewModel({
                parentLocator: this.locator,
                locator: listView.typeName + '.open-favorite-settings.image',
                source: this.defineComputed(() => {
                    let favorites = RADApplication.getInstance().user.getUserSpecificData('RAD_FAVOURITESITES', {})();
                    let address = NavigationService.getInstance().getAddress().toString();

                    const urlPrefix = '$$TEMPLATE_HANDLER$$?TemplateName=$$TEMPLATE_STYLE$$&ImageName';
                    if (favorites != null && address in favorites) {
                        return `${urlPrefix}=${GlobalConfiguration.inlineImages.FAVOURITE_ACTIVE}`;
                    } else {
                        return `${urlPrefix}=${GlobalConfiguration.inlineImages.FAVOURITE_INACTIVE}`;
                    }
                }),
                alternativeText: new this.LabelViewModel({
                    ergName: 'FAVOURITE_TOOLTIP'
                })
            }),
            isActive: false,
            isVisible: RADApplication.getInstance().isRADlicensed,
            isEnabled: true
        });
    }

    public buildOperationLinkViewModel(operation: CoreFrameDTOs.IOperationDTO, listView: CoreFrameDTOs.IListViewDTO): LinkViewModelT {
        return new this.LinkViewModel({
            parentLocator: this.locator,
            locator: listView.typeName + ".toolbar.operation." + operation.name,
            label: new this.LabelViewModel({
                ergName: operation.ergName,
                parentLocator: this.locator,
                locator: listView.typeName + ".toolbar.operation." + operation.name + ".label"
            }),
            image: new this.ImageViewModel({
                source: operation.iconUrl,
                parentLocator: this.locator,
                locator: listView.typeName + ".toolbar.operation." + operation.name + ".image",
                alternativeText: new this.LabelViewModel({
                    ergName: operation.ergName ?? ''
                })
            }),
            tooltip: new this.LabelViewModel({
                ergName: operation.tooltip
            }),
            isActive: false,
            isVisible: true,
            isEnabled: this.defineComputed(() => {
                if (!operation.hasRight) {
                    return false;
                }

                if (operation.isNeedingParameters) {
                    let selected = this.dataGrid.selected();
                    return operation.handlesMultipleInstances ? selected.length > 0 : selected.length == 1;
                }

                return true;
            }),
            onClick: () => {
                $.when(this.uiListener.onBeforeCallOperation(this, operation.name)).then((allowOperation: boolean) => {
                if (allowOperation === false) {
                    // Operation wurde abgebrochen bzw. Client-seitig behandelt
                    return;
                }

                let pdTypeName = listView.typeName;
                let operationName = operation.name;
                let operationParameters = [];
                let contextParameters = {
                    CALL_ENVELOPE_CURRENT_CLIENT_LV_FILTER: this.dataGrid.getFilterExpression(),
                    CALL_ENVELOPE_CURRENT_CLIENT_LV_ORDER: this.dataGrid.getOrderExpression(),
                    CALL_ENVELOPE_CURRENT_PRINCIPAL_LV_FILTER: RADApplication.getInstance().getServerValueForPrincipalFilterMode(this.principalFilterMode()),
                    CALL_ENVELOPE_CURRENT_CLIENT_LV_ITERATOR_PARAMETER: this.dataGrid.getIteratorParameter()
                };


                if (operation.isNeedingParameters) {
                    let selected = this.dataGrid.selected();

                    if (selected.length === 0) {
                        RADApplication.getInstance().showMessageBox(this.MessageBoxViewModel.createNoticeMessageBox(null, 'NOSELECTION_OPERATION_NOTICE'));
                        return;
                    }

                    let operationParameter: any;
                    if (operation.handlesMultipleInstances) {
                        operationParameter = selected;
                    }
                    else {
                       operationParameter = selected[0];
                    }

                    operationParameters.push(ko.unwrap(operationParameter));
                }

                let operationCall = this.uiListener.onCallOperation(this, operationName, operationParameters);

                if (Utilities.isNullOrUndefined(operationCall)) {
                    FrontController.managedCallStaticOperation(pdTypeName,
                        operationName,
                        operationParameters,
                        contextParameters,
                        (managedStaticOperationCall, operationResultDto) => {
                            if (this.validateStatus(operationResultDto)) {
                                this.handleOperationResultDTO(operation, operationResultDto);

                                managedStaticOperationCall.onDefaultSuccess(managedStaticOperationCall,
                                    operationResultDto);

                                if (managedStaticOperationCall.isClosed &&
                                    managedStaticOperationCall.contextNeedsRefresh) {
                            let currentDetailViewContext = RADApplication.getInstance().currentDetailViewContext();
                                    let isDetailView = NavigationService.getInstance().getAddress().toString().indexOf('DetailView') >
                                        -1;

                            if (!isDetailView && currentDetailViewContext == null) {
                                this.refresh();
                            }
                        }
                    }
                });
                } else {
                    operationCall.then((operationResultDto) => {
                        this.handleOperationResultDTO(operation, operationResultDto);
                    });
            }
                });
            }
        });
    }

    private handleOperationResultDTO(operation: CoreFrameDTOs.IOperationDTO, operationResultDto: CoreFrameDTOs.IOperationResultDTO): void {
        if (operation.showResult === true || operation.showResult + '' === 'true') {
            let returnValue = operationResultDto.returnValue || 'null';
            // Manuelles Escaping ist hier nicht nötig, da die MessageBox dies übernimmt
            let message = returnValue + '';
            RADApplication.getInstance().showMessageBox(
                this.MessageBoxViewModel.createNoticeMessageBox(message));
        }

        this._refreshSummaryView(true);
        this.uiListener.onAfterCallOperation(this, operation.name, operationResultDto);
    }

    public buildExportLinkViewModel(exportType: string, visible: any, labelParams: any, imageParams: any, typeName: string, customAction: (exportType: string) => void = null): LinkViewModelT {
        const action = customAction ?? ((exportType: string) => this.exportData(exportType));
        return ListViewHelper.buildExportLinkViewModel(exportType, visible, labelParams, imageParams, typeName, this.locator, action);
    }

    public exportData(exportType: any, showFilter = true): void {
        let iteratorId = this.dataGrid.getIteratorId();
        if (iteratorId != null) {
            Loader.getInstance().show();

            let filter = this.dataGrid.filter.getFilterExpressionForExport();
            RADEnvironmentProxy.getInstance().exportData({
                iteratorID: iteratorId,
                exportType: exportType,
                columns: _.pluck(_.filter(this.dataGrid.columns(), (column) => { return !column.hidden; }), 'title'),
                filter: JSON.stringify(FilterHelper.createFilterObjectForStaticFilter(filter)),
                showFilter: showFilter
            }).then((downloadURL) => {
                DownloadHelper.openDownloadDialogFromApplicationAsync(downloadURL);
            }).always(() => {
                Loader.getInstance().hide();
            });
        }
    }

    /**
     * Refreshs the list view
     * @param viewRefreshed is the whole view or just data refreshed?
     */
    public refresh(viewRefreshed: boolean = false): boolean {
        if (this.isDisposed)
            return false;

        // Erst, wenn überhaupt eine ListView vom Server geladen wurde, kann diese auch refreshed werden
        if (this.listView() == null)
            return false;

        this.refreshPersistenceContext(viewRefreshed);
        return true;
    }

    /**
     * Refreshs the listview by recreating the persistence context, load listview dto and data
     * @param viewRefreshed is the whole view or just data refreshed?
     */
    public refreshPersistenceContext(viewRefreshed: boolean = false): void {
        this.increaseBusyCounter();

        this.isRefreshing = true;
        $.when(this.deletePersistenceContext())
            .then((contextDeleted) => {
                if (this.isDisposed !== false || contextDeleted === false) {
                    return undefined;
                }

                return $.when(this.createPersistenceContext())
                    .then((contextCreated) => {
                        if (this.isDisposed !== false || contextCreated === false) {
                            return;
                        }

                        this.loadListView(true, viewRefreshed);
                        this.raiseHeaderChange();
                        this._refreshSummaryView(true);
                        if(!Utilities.isNullOrUndefined(this.uiListener) && Utilities.isFunction(this.uiListener.onAfterRefresh))
                            this.uiListener.onAfterRefresh(this);
                    });
            }).always(() => {
                this.decreaseBusyCounter();
                this.isRefreshing = false;
            });
    }

    /**
     * Informiert den UIListener darüber, dass die ListView geladen wurde
     */
    public notifyListViewReady() {
        this.raiseHeaderChange();
        this.sendEnteredMessage();
        this.uiListener.onListViewReady(this);
    }

    public sendEnteredMessage() {
        Messenger.createMessageAndSend('ListViewEnteredMessage', {
            context: this
        });
    }

    private _exitedMessageSent = false;
    public sendExitedMessage() {
        if (this._exitedMessageSent)
            return;

        Messenger.createMessageAndSend('ListViewExitedMessage', {
            context: this
        });

        Messenger.disposeMessage('ListViewEnteredMessage');
        Messenger.disposeMessage('DetailViewEnteredMessage');

        this._exitedMessageSent = true;
    }

    /**
     * Gibt zurück, ob die ListView zwingend anhand des Namens geladen werden soll
     */
    protected forceLoadListViewByName(): boolean {
        return this.forceSelectingLVByName;
    }

    /**
     * Gibt die ID der View zurück
     */
    protected getViewId(): string {
        return this.viewId;
    }

    /**
     * Gibt den Namen der View zurück
     */
    public getViewName(): string {
        return this.viewName;
    }

    /**
     * Loads listview dto by information from factory
     * @param refresh should all viewmodels be updated instead new created?
     * @param viewRefreshed is the whole view or just data refreshed?
     */
    public loadListView(refresh: boolean = false, viewRefreshed: boolean = false): void {
        this.increaseBusyCounter();
        this.fetchListView().then((listViewDTO) => {
            if (this.isDisposed)
                return;

            if (listViewDTO == null) {
                this.navigateToHome();
                return;
            }

            if (this.validateStatus(listViewDTO)) {
                this.onListViewLoaded(listViewDTO, refresh, viewRefreshed);
            }
        }).fail(e => {
            console.error(e);
            this.navigateToHome();
        }).always(() => {
            this.decreaseBusyCounter();
        });
    }

    private navigateToHome() : void {
        if (this.isEmbedded)
            return;

        // TODO: In ein ResourceItem auslagern
        const staticWarning = 'Die von Ihnen angeforderte ListView konnte nicht geladen werden. Sie wurden zur Startseite weitergeleitet.';
        RADApplication.getInstance().showMessageBox(this.MessageBoxViewModel.createWarningMessageBox(staticWarning));
        NavigationService.getInstance().navigateToHome();
    }

    protected fetchListView(): JQueryPromise<IListViewDTO> {
        const viewName = this.getViewName();
        if (viewName || this.forceLoadListViewByName()) {
            return RADEnvironmentProxy.getInstance().getListViewByName({
                listViewName: viewName
            });
        }

        const viewId = this.getViewId();
        if (viewId) {
            return RADEnvironmentProxy.getInstance().getListView({
                listViewPDO_ID: viewId
            });
        }

        return Utilities.resolveImmediately(null);
    }

    public raiseHeaderChange() {
        /** SCHLEUPENGRC-1088: Nach einem Mandantenwechsel sind PageTitle und _HeaderTitle leer, jedoch
         * befindet sich der User weiterhin auf derselben Listenansicht: Kein Refresh nötig. */
        if ((Utilities.isNullOrUndefined(this.pageTitle) || Utilities.isBlank(this.pageTitle as string))
            && (Utilities.isNullOrUndefined(this._HeaderTitle) || Utilities.isBlank(this._HeaderTitle)))
            return;

        //FavouriteToggleControlViewModel.SetInitFavName(PageTitle);
        let prefix = this.getPageTitlePrefix();
        let msg = {} as any;

        msg.title = this._HeaderTitle;
        msg.prefix = prefix;

        Messenger.createMessageAndSend('ChangeHeaderTitleMessage', msg);
    }

    public getPageTitleErgName(listViewDTO) {
        if (!listViewDTO) {
            listViewDTO = this.listView();
            if (!listViewDTO)
                return null;
        }

        return listViewDTO.ergNamePluralized;
    }

    public getPageTitle(listViewDTO: CoreFrameDTOs.IListViewDTO): string {
        return ResourceManager.getInstance().get(this.getPageTitleErgName(listViewDTO));
    }

    public getPageTitlePrefix() {
        return ResourceManager.getInstance().get("LISTVIEW_PAGETITLE_PREFIX");
    }

    public onBeforeListViewLoaded(listViewDTO: CoreFrameDTOs.IListViewDTO): void {
        // Hook method
    }

    /**
     * Callback when listview dto was loaded
     * @param refresh should all viewmodels be updated instead new created?
     * @param viewRefreshed is the whole view or just data refreshed?
     */
    public onListViewLoaded(listViewDTO: CoreFrameDTOs.IListViewDTO, refresh: boolean = false, viewRefreshed: boolean = false): void {
        if (!refresh && !this.uiListener) {
            this.createUIListener(listViewDTO);
        }

        if (this.uiListener)
            this.uiListener.onBeforeListViewRender(this, listViewDTO);

        this.onBeforeListViewLoaded(listViewDTO);

        //Sonderfall für Aufruf einer LV mit einem ALV-Iterator
        if (this.isAssociationList() && !String.isNullOrEmpty(listViewDTO.defaultOrder) && !this.ignoreContext) {
            listViewDTO.defaultOrder = listViewDTO.defaultOrder.replace(/this\./g, 'this.' + this.contextRelation + '.');
        }

        if (this.isEmbedded) {
            if (refresh) {
                this.updateDataGrid(listViewDTO, viewRefreshed);
                this.updateToolbar(listViewDTO, viewRefreshed);
            } else {
                this.createDataGrid(listViewDTO);
                this.afterDataGridCreated();
                this.splitterHorizontal = this.createHorizontalSplitter(listViewDTO);
                this.splitterVertical = this.createVerticalSplitter(listViewDTO);
                this.createToolbar(listViewDTO);
            }

            this.listView(listViewDTO);
        }
        else {
            if (refresh) {
                this.updateDataGrid(listViewDTO, viewRefreshed);
                this.updateToolbar(listViewDTO, viewRefreshed);
                this.listView(listViewDTO);
                if (viewRefreshed) {
                    this.notifyListViewReady();
                }
            } else {
                this.pageTitle = this.getPageTitle(listViewDTO);
                this._HeaderTitle = this.pageTitle;
                this.createDataGrid(listViewDTO);
                this.afterDataGridCreated();
                this.splitterHorizontal = (() => this.createHorizontalSplitter(listViewDTO))();
                this.splitterVertical = (() => this.createVerticalSplitter(listViewDTO))();
	            this.createPageTitle(listViewDTO);
	            this.createToolbar(listViewDTO);
	            this.registerForPrincipalChangedMessage();

	            RADApplication.getInstance().currentListViewContext(this);
	            this.listView(listViewDTO);
                this.notifyListViewReady();
	        }
    	}
    }

    public afterDataGridCreated() {
        this.defineComputed(() => {
            let selected = this.dataGrid.selected();

            ko.ignoreDependencies(() => {
                if (this.dataGrid.selectionWasProgrammaticallyResetted()) {
                    this.dataGrid.selectionWasProgrammaticallyResetted(false);
                    return;
                }

                const pdoId = selected.length > 0 ? selected[0] : null;

                // bei einer Navigation aus einer View heraus mit einem selektierten Objekt, worauf man keine Rechte hat, darf beim refresh der LV das Objekt nicht via PDO_ID in der SV geladen werden
                if (!this.dataGrid.pdoIdDataSet().hasOwnProperty(pdoId)) {
                    this.currentSummaryViewPDO(null);
                    this.setUrlStates(null);
                    return;
                }

                this.setUrlStates(pdoId);
                if (pdoId) {
                    this.selectedPDO = pdoId;
                    this.currentSummaryViewPDO(pdoId.toString());
                }
                else {
                    this.currentSummaryViewPDO(null);
                }
            });
        });
    }

    /**
     * Registrierung für Navigations-Message falls der Kontext mit aussstehenden Änderungen verlassen wird
     */
    public registerForPrincipalChangedMessage() {
        this.registerForMessageId('PrincipalChangedMessage', (message) => {
            if (!this.isDisposed && RADApplication.getInstance().currentDetailViewContext() == null && this.viewFactory != null && this.viewFactory.identifier == NavigationService.getInstance().getVisibleViewIdentifier()) {
                NavigationService.getInstance().refresh();
            }
        });
    }

    /**
     * Setzt die globale Referenz auf den aktuellen ListViewContext zurück
     */
    protected resetCurrentListViewContext(): void {
        RADApplication.getInstance().currentListViewContext(null);
    }

    /**
     * Setzt die URL-relevanten States
     */
    private setUrlStates(selectedPdoId: any): void {
        if (this.isEmbedded)
            return;
      
        NavigationService.getInstance().setParametersToAdress(this.identifier, {
            SelectedPDO: selectedPdoId
        }, false);
    }

    /**
     * Sets initial selected PDO-ID
     * @param selected
     */
    public setInitialSelected(selected: string): void {
        this.selectedPDO = selected;
        this.dataGrid.initial = parseInt(selected);
    }

    public updateSummaryViewSize(summaryViewPane: SplitterPaneViewModelT, elementSize: number, screenRatio: number) {
        if (this.isDisposed || !summaryViewPane || summaryViewPane.isDisposed)
            return;

        const savedScreenRatio = summaryViewPane.size();
        let savedScreenRatioInt = 0;

        if (savedScreenRatio != null) {
            if (typeof savedScreenRatio === 'string') {
                if (savedScreenRatio.indexOf('%') === -1) {
                    savedScreenRatioInt = parseInt((parseInt(savedScreenRatio) / elementSize * 100) as any);
                } else {
                    savedScreenRatioInt = parseInt(savedScreenRatio);
                }
            } else {
                savedScreenRatioInt = savedScreenRatio / elementSize * 100;
            }

            screenRatio = savedScreenRatioInt;
        }

        if (!screenRatio || screenRatio > 90 || screenRatio < 10) {
            screenRatio = 50;
        }

        summaryViewPane.size(screenRatio + '%');
    }

    /**
     * Überschreibt das Standard-Disposing
     */
    protected disposeInternal() : void {
        if (this._selectBaseObjectWindowViewModel && !this._selectBaseObjectWindowViewModel.isDisposed) {
            this._selectBaseObjectWindowViewModel.dispose();
        }

        this.sendExitedMessage();

        this.deletePersistenceContext();
        this.resetCurrentListViewContext();
        super.disposeInternal();
    }
}

ComponentManager.setViewModel('ListViewViewModel', ListViewViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');